// extracted by mini-css-extract-plugin
export default {"title":"BookmarksFeed_title__n4tdE","bookmarks-feed":"BookmarksFeed_bookmarks-feed__KrcwR","bookmarks-feed__items":"BookmarksFeed_bookmarks-feed__items__F9MZs"};